var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 169,
    viewBox: "0 0 161 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_545_8654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.109 82.6406H142.376L171.178 53.8386C177.957 47.0599 177.957 36.0697 171.178 29.291C164.399 22.5122 153.409 22.5122 146.63 29.291L117.828 58.0929V17.3594C117.828 7.77506 110.059 0 100.469 0C90.8844 0 83.1093 7.76895 83.1093 17.3594V58.0929L54.3074 29.291C47.5287 22.5122 36.5384 22.5122 29.7597 29.291C22.981 36.0697 22.981 47.0599 29.7597 53.8386L58.5617 82.6406H17.8282C8.24381 82.6406 0.46875 90.4095 0.46875 100C0.46875 109.59 8.2377 117.359 17.8282 117.359H58.5617L29.7597 146.161C22.981 152.94 22.981 163.93 29.7597 170.709C36.5384 177.488 47.5287 177.488 54.3074 170.709L83.1093 141.907V182.641C83.1093 192.225 90.8783 200 100.469 200C110.053 200 117.828 192.231 117.828 182.641V141.907L146.63 170.709C153.409 177.488 164.399 177.488 171.178 170.709C177.957 163.93 177.957 152.94 171.178 146.161L142.376 117.359H183.109C192.694 117.359 200.469 109.59 200.469 100C200.469 90.4156 192.7 82.6406 183.109 82.6406Z",
    fill: "#393A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_545_8654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0.46875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfter1);
export default __webpack_public_path__ + "static/media/After1.b2eb6ccb786b5c9907876e261d568d46.svg";
export { ForwardRef as ReactComponent };